import _http_v1 from "../../../../../http_requests/_http_v1"
import _http_v2 from "@packs/http_requests/_http_v2"

export default {
    getMeasurements(options = {}, format="json", GENERAL_OPTIONS){

        if(options.station_prefix_ids.length == 1 && GENERAL_OPTIONS.station_type === 'flu'){
            options.parameter_type_ids = [2]
        }

        return _http_v2.request("measurements?format="+format,'GET', options)
    },
    getNewMeasurements(options = {}, format="json", GENERAL_OPTIONS){
        return _http_v2.request("new_measurements?format="+format,'GET', options)
    }
}